import { getWidgetConfig } from '../runtime/widgetConfig'
import { encodeMobileUploadPayload } from './mobileUploadPayload'

export const DEFAULT_MOBILE_UPLOAD_URL = 'https://www.pixelfoto-express.de/mobile-upload'

/**
 * Link für den Handy-Upload (QR-Code). Eine Implementierung für alle Einstiege
 * (image-tool, entry, product-upload-drawer, configurator/upload).
 */
export function buildMobileUploadUrl(input: { projectCode: string; categoryId?: number | null; productId?: number | null }): string {
  const cfg = getWidgetConfig() as any
  const base = String(cfg?.mobileUploadUrl || DEFAULT_MOBILE_UPLOAD_URL).trim() || DEFAULT_MOBILE_UPLOAD_URL
  const url = new URL(base)
  const categoryId = Number(input.categoryId || 0)
  const productId = Number(input.productId || 0)
  url.searchParams.set('data', encodeMobileUploadPayload({
    projectCode: String(input.projectCode || '').trim(),
    ...(categoryId > 0 ? { categoryId } : {}),
    ...(productId > 0 ? { productId } : {}),
  }))
  return url.toString()
}

export const MOBILE_UPLOAD_QR_OPTIONS = {
  margin: 1,
  width: 220,
  color: { dark: '#0f172a', light: '#ffffff' },
} as const
